const paymentAssuranceSelector = '.seal-payment-assurance';
const triggerSelector = '[data-seal-payment-assurance-trigger]';
const resetDelay = 5000;

function resetLoadingState(container) {
  container.classList.remove('is-loading');

  container.querySelectorAll(triggerSelector).forEach((trigger) => {
    trigger.classList.remove('is-loading');
    trigger.removeAttribute('aria-busy');
    trigger.removeAttribute('disabled');
  });
}

function getCheckoutTrigger(container) {
  const productForm = container.closest('product-form-component');
  if (!productForm) return undefined;

  return (
    productForm.querySelector('[data-seal-ecoseal-checkout]:not([hidden]) [data-seal-ecoseal-checkout-button]') ||
    productForm.querySelector('[data-seal-ecoseal-mix-checkout]:not([hidden]) [data-seal-ecoseal-mix-checkout-button]') ||
    productForm.querySelector('.shopify-payment-button__more-options') ||
    productForm.querySelector('.shopify-payment-button__button')
  );
}

function handleClick(event) {
  const trigger = event.target.closest(triggerSelector);
  if (!trigger) return;

  const container = trigger.closest(paymentAssuranceSelector);
  if (!container || container.classList.contains('is-loading')) return;

  event.preventDefault();

  container.classList.add('is-loading');
  trigger.classList.add('is-loading');
  trigger.setAttribute('aria-busy', 'true');
  trigger.setAttribute('disabled', 'disabled');

  const resetTimer = window.setTimeout(() => resetLoadingState(container), resetDelay);
  const checkoutTrigger = getCheckoutTrigger(container);

  if (checkoutTrigger && !checkoutTrigger.disabled) {
    checkoutTrigger.click();
    return;
  }

  window.clearTimeout(resetTimer);
  resetLoadingState(container);
  window.location.href = window.routes?.cart_url || '/cart';
}

function resetAllLoadingStates() {
  document.querySelectorAll(paymentAssuranceSelector).forEach(resetLoadingState);
}

document.addEventListener('click', handleClick);
window.addEventListener('pagehide', resetAllLoadingStates);
window.addEventListener('pageshow', resetAllLoadingStates);
